// 数据回收模块
export default {
    DataRecycling: {
        DataOverview: '数据概览',
        UpdatedOn: '更新于',
        NewToday: '今日新增',
        TotalDataVolume: '总数据量',
        AverageAnswerTime: '平均答题时长',
        TopicStatistics: '题目统计',
        Export: '导出',
        Operate: '操作',
        Preview: '预览',
        NumberOfRespondents: '回答人数',
        Download: '下载',
        LoadMore: '加载更多',
        ExportType: '导出类型',
        DataReport: '数据报表',
        ExportFormat: '导出格式',
        ExportCSV: '导出CSV',
        ExportToExcel: '导出Excel',
        ExportWord: '导出Word',
        Export: '导 出',
        ModifyQuestionnaireTip: '您确认修改此问卷吗？该问卷所有数据收集将被停止，答卷链接暂时关闭！',
        ModificationPrompt: '修改提示',
        CustomTitle: '自定义标题',
        Pie: '饼图',
        Histogram: '柱状图',
        BarChart: '条形图',
        Ring: '圆环',
        StackedBarChart: '堆积柱状图',
        StackedBarChart: '堆积条形图',
        RadarChart: '雷达图',
        DataPreparationInProgress: '数据准备中，预计5分钟后完成。前往',
        MyDownload: '我的下载',
        CanViewProgress: '可查看进度',
        Referrer: '访问来源',
        ExportData: '导出数据',
        ExportChart: '导出图表',
        PleaseSelect: '请选择',
        StackedColumnChart: '堆叠柱状图',
        StackedBarChart: '堆叠条形图',
        FoldLine: '折线',
        Filter: '筛选',
        FilterMeetsTheFollowingCriteria: '筛选符合以下',
        Data: '的数据',
        AnswerToTheQuestion: '题目答案',
        Delete: '删除',
        ShowSatisfaction: '显示满足以下',
        AnswerSheet: '的答卷',
        AddFilterCriteria: '添加筛选条件',
        AnswerDate: '答题日期',
        To: '至',
        StartDate: '开始日期',
        EndDate: '结束日期',
        Clear: '清空',
        AllConditions: '全部条件',
        AnyCondition: '任意条件',
        All: '全部',
        Custom: '自定义',
        Selected: '选中',
        NotSelected: '未选中',
        IsEmpty: '为空',
        NotEmpty: '不为空',
        Contain: '包含',
        NotIncluded: '未包含',
        OnlySelect: '只选中',
        RestoreToDefault: '清空筛选条件后，筛选条件都将恢复为默认样式',
        ConfirmEmptying: '确定清空',
        LoadError: '加载错误',
        QuestionBasedStatistics: '分题统计',
        CrossAnalysis: '交叉分析',
        SourceAnalysis: '来源分析',
        SubtitleStatisticsCopy: '分题统计复制',
        DataAnalysis: '数据分析',
        CrossChart: '交叉图表',
        AddCrossAnalysis: '添加交叉分析',
        NotCrossChart: '该项目暂无交叉图表',
        CrossChartsSupport: '交叉图表只支持单选题和多选题',
        AddCrossChart: '添加交叉图表',
        Argument: '自变量',
        DependentVariable: '因变量',
        HideChart: '隐藏图表',
        HideTable: '隐藏表格',
        DisplaySettings: '显示设置',
        TotalNumberOfInterviewees: '受访总人数',
        RowPercentage: '行百分比',
        ChartType: '图表类型',
        DisplayChart: '显示图表',
        DisplayTable: '显示表格',
        DataScreening: '数据总览',
        NewDataAddedToday: '今日新增数据',
        DataDetails: '数据详情',
        SetUp: '设置',
        ExportAttachments: '导出附件',
        ExportPicture: '导出图片',
        ExportRecording: '导出录音',
        ExportContent: '导出内容',
        DataDetailsTable: '数据详情表',
        DataType: '数据类型',
        RawData: '原始数据',
        CodedData: '编码数据',
        ExhibitionFormat: '展出形式',
        OneQuestionOneColumn: '一题一列',
        OneQuestionWithMultipleColumns: '一题多列',
        Details: '详情',
        FullName: '姓名',
        Age: '年龄',
        Year: '岁',
        Gender: '性别',
        Education: '学历',
        CellPhoneNumber: '手机号',
        Mailbox: '邮箱',
        ID: '身份证号',
        Address: '地址',
        SampleStatusName: '样本状态名称',
        ExportImageSettingsField: '导出图片设置字段',
        Route: '路径',
        PleaseEnterContent: '请输入内容',
        Name: '名称',
        LabelTip: '注意：标签以方括号成对的形式出现，请在删减路径标签时注意方括号的闭合，保证生成路径的合法性。',
        State: '状态',
        AllImages: '全部图片',
        CompleteImage: '完成图片',
        IdentifyingImages: '甄别图片',
        ExportRecordingSettingsFields: '导出录音设置字段',
        RecordAll: '全部录音',
        CompleteRecording: '完成录音',
        IdentifyingRecordings: '甄别录音',
        Source: '来源',
        Interview: '面访',
        TelephoneSurveys: '电访',
        SetDisplayFields: '设置显示字段',
        SampleFields: '样本字段',
        WhetherToChoose: '是否选用',
        IsItFixedOnTheLeftSide: '是否左侧固定',
        QuestionnaireFields: '问卷字段',
        VisitorField: '访员字段',
        GeographicalDistribution: '地域分布',
        AccessingTheEnvironment: '访问环境',
        ByDeviceType: '按设备类型',
        ByBrowser: '按浏览器',
        ByOperatingSystem: '按操作系统',
        Province: '省份',
        SetDisplay: '设置显示',
        NumberOfRespondents: '答题人数',
        ViewChartDisplaySettings: '查看图表显示设置',
        DisplayByTitle: '按照题目显示',
        Topic: '题目',
        DisplayAccordingToQuestionType: '按照题型显示',
        
        InputTypeQuestion: '输入类型题',
        MultipleChoiceQuestions: '多选题',
        StarRating: '星级评分',
        TrueOrFalse: '判断题',
        DateSelection: '日期选择',
        SortQuestion: '排序题',
        AddressLocation: '地址位置',
        CitySelection: '城市选择',
        Timing: '时间选择',
        MatrixTypeQuestions: '矩阵类型题',
        MatrixRadioSelection: '矩阵单选',
        MatrixMultipleSelection: '矩阵多选',
        MatrixStarRating: '矩阵星级评分',
        MatrixFillingInTheBlank: '矩阵填空',
        FillInTheBlankWithMultipleRowsOfMatrix: '矩阵多行填空',
        MatrixCombination: '矩阵组合',
        MoreQuestionTypes: '更多题型',
        Headings: '段落标题',
        Paging: '分页',
        PersonalInformation: '个人信息',
        SingleLineInputBox: '单行输入框',
        Career: '职业',
        UploadFiles: '上传文件',
        FillInTheBlankHorizontally: '横向填空',
        MultipleBlankFilling: '多项填空',
        CascadeQuestions: '级联题',
        SpecificGravityQuestion: '比重题',
        ScaleQuestions: '量表题',
        MultilineInputBox: '多行输入框',
        FillInTheBlanks: '填空题',
        PictureSelection: '图片选择',
        MultipleChoiceQuestions: '选择类型题',
        MultipleChoice: '单选题',
        DropDownList: '下拉框',
        AnswerSheetDetails: '答卷详情',
        AnswerInformation: '答题信息',
        TotalScore: '答题总分',
        TextReading: '文本阅读',
        AnswerSheetReading: '答卷阅读',
        ViewAttachments: '查看附件',
        Photo: '照片',
        NoPicturesObtained: '暂未获取到 图片信息',
        SoundRecording: '录音',
        AudioNotSupported: '您的浏览器不支持 audio 元素。',
        Positioning: '定位',
        LocationNotObtained: '暂未获取到 定位信息',
        IncompleteData: '数据不完整，请刷新页面',
        SampleNumber: '样本编号'
    },
  };